<ng-container *ngIf="download">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<!-- *ngIf="ready" -->
<ng-container>
  <ng-container>
    <div class="butonera">
      <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
        <app-help key='Inversion26'></app-help>
      </button>
    </div>

  </ng-container>

  <ng-container>
    <app-result-total *ngIf="dataResultTotals" [resultTotals]="dataResultTotals"></app-result-total>
    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="true" [hasButton]="true"
      [actionsTemplate]="actionsButtons" (amountNumberClick)="onAmountNumberClick($event)"
      (descriptionInvestmentClick)="onDescriptionInvestmentClick($event)"
      (providerInvestmentClick)="onProviderInvestmentClick($event)" (selectedChange)="onSelectedChange($event)">
    </app-table>

    <!-- <div class="container-fluid">
      <div class="row">
        <div class="col-md-2 col-lg-1 col-xs-12">
          <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="getList()" class="form-control"
            style="margin-left: 20px;">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </select>
        </div>
        <div class="col-md-10 col-lg-11 col-xs-12">
          <pagination (pageChanged)="pageChanged($event)" [(ngModel)]="currentPage" [totalItems]="totalItems"
            [itemsPerPage]="itemsPerPage" [maxSize]="5" previousText="Anterior" style="float: right;margin-right: 20px;"
            nextText="Siguiente"></pagination>
        </div>
      </div>
    </div> -->
  </ng-container>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/presupuesto.svg" class="invoiceImage" />
      <p style="color: #9e9e9e">
        No tiene ninguna inversión, presione + para crear una.
      </p>
    </div>
  </ng-container>



  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of dataSource | filter: uid:'uid'; trackBy: trackByIndex">
      <ul class="custom-class">
        <li (click)="edit(uid)">
          <a>
            <mat-icon>create</mat-icon>Editar
          </a>
        </li>
        <li (click)="delete(uid)">
          <a>
            <mat-icon>warning</mat-icon>Borrar
          </a>
        </li>
        <ng-container *ngIf="row.isImage">
          <li (click)="downloadFileImage(row.uid)">
            <a>
              <mat-icon>image</mat-icon> Imagen
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="row.isPdf">
          <li (click)="downloadFilePdf(row.uid)">
            <a>
              <mat-icon>attachment</mat-icon> Documento
            </a>
          </li>
        </ng-container>
        <li (click)="pay(uid)">
          <a>
            <mat-icon>payment</mat-icon>Pago
          </a>
        </li>
        <li (click)="addManualAccountMovements()">
          <a>
            <mat-icon>show_chart</mat-icon>Contabilizar (Asiento libre)
          </a>
        </li>
      </ul>
    </ng-container>
  </ng-template>
</ng-container>
<ng-container *ngIf="ready === false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>